export const productStatusDisplayMap = {
  UNKNOWN_STATUS: 'Unknown',
  PILOT: 'Pilot',
  ALPHA: 'Alpha',
  BETA: 'Beta',
  GENERAL_AVAILABILITY: 'General Availability',
  END_OF_LIFE: 'End of Life',
  IN_DEVELOPMENT: 'In Development',
};
